module.exports = __webpack_public_path__ + "fonts/circular-medium.2a4f3a1.woff";